import { render, staticRenderFns } from "./LightDarkSwitch.vue?vue&type=template&id=6d0a34ac&scoped=true&"
import script from "./LightDarkSwitch.vue?vue&type=script&lang=ts&"
export * from "./LightDarkSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./LightDarkSwitch.vue?vue&type=style&index=0&id=6d0a34ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0a34ac",
  null
  
)

export default component.exports